import { render, staticRenderFns } from "./cateDialog.vue?vue&type=template&id=e11d6972&scoped=true&"
import script from "./cateDialog.vue?vue&type=script&lang=js&"
export * from "./cateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11d6972",
  null
  
)

export default component.exports